// extracted by mini-css-extract-plugin
export default {"details":"PreviewableList_details__7Aou9","actions":"PreviewableList_actions__xxF1Y"};